import Editor from "./Editor";

export default class AssignmentPoolIgnore {
    private readonly _ignoredAt: Date;
    private readonly _editor: Editor;
    private readonly _assignmentPool: any;
    constructor({
        ignoredAt,
        editor,
    }, assignmentPool) {
        this._ignoredAt = new Date(ignoredAt);
        this._editor = new Editor(editor);
        this._assignmentPool = assignmentPool;
    }

    get ignoredAt(): Date {
        return this._ignoredAt;
    }

    get editor(): Editor {
        return this._editor;
    }

    get assignmentPool(): any {
        return this._assignmentPool;
    }
}
